import { render } from "./ModalColorsSelector.vue?vue&type=template&id=4f52493e&scoped=true"
import script from "./ModalColorsSelector.vue?vue&type=script&lang=js"
export * from "./ModalColorsSelector.vue?vue&type=script&lang=js"

import "./ModalColorsSelector.vue?vue&type=style&index=0&id=4f52493e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f52493e"]])

export default __exports__